import { render, staticRenderFns } from "./BtnDeflatorContrato.vue?vue&type=template&id=4fc4a52c&"
import script from "./BtnDeflatorContrato.vue?vue&type=script&lang=js&"
export * from "./BtnDeflatorContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports